import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CookieConsentService } from './cookie-consent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  readonly cookieConsentService: CookieConsentService = inject(CookieConsentService);

  ngOnInit(): void {
    this.cookieConsentService.init();
  }
}
